<template>
  <div
      style="width: 100vw;height: 100vh;color: rgba(229, 229, 229, 1);background-color: rgba(2, 15, 31, 1);position: relative;overflow: scroll;">
    <div style="height: 20px;width: 100%;"></div>
    <div class="alibabaPuHuiTiFontFamily" style="font-size:18px;font-weight: 400;text-align: center;">
      《吉林一号共生地球会员服务协议》
    </div>
    <div class="content-text" style="margin-top: 27px;">
      《吉林一号共生地球会员服务协议》（以下简称“本协议”）由长光卫星技术股份有限公司（以下简称“甲方”，即“吉林一号共生地球”运营方）与开通、使用“吉林一号共生地球”APP会员服务的用户（以下简称“乙方”）签订，旨在明确双方就乙方使用“吉林一号共生地球”会员服务（以下简称“会员服务”）的权利义务。乙方点击“开通会员”或实际使用会员服务，即视为已完整阅读、理解并同意本协议全部条款。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      本协议为《吉林一号共生地球服务协议》和《吉林一号共生地球隐私政策》的补充协议，与前述文件构成统一整体，具有同等法律效力。本协议与前述文件内容冲突的，以本协议为准；本协议未约定的，适用前述文件约定。甲方有权根据业务调整对本协议条款进行修改（包括但不限于服务内容、费用标准、使用规则等），修改后将通过“吉林一号共生地球”APP公告、站内消息等方式通知乙方；乙方有义务不定期地查阅本协议及相关公告、通知，若不同意修改，有权申请终止服务；若继续使用，视为已阅读、理解并完全同意修改后的协议条款。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      第一条 会员服务定义与范围
    </div>
    <div class="content-text" style="margin-top: 20px;">
      1.1 会员服务是甲方为乙方提供的“吉林一号共生地球”APP专属增值服务，核心围绕卫星影像相关权益展开，具体服务内容以APP内公示的会员权益清单为准，包括但不限于卫星影像查看、区域订阅等服务。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      1.2
      甲方有权根据业务规划调整会员服务的具体内容（如新增/删减权益、优化服务形式），调整后将提前通过APP公告或站内消息通知乙方，无需单独取得乙方同意；若调整导致会员核心权益（影像查看、区域订阅）实质性缩减，甲方将为乙方提供合理补偿方案（如延长会员期限、补充等价权益）。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      第二条 会员权益与使用限制
    </div>
    <div class="content-text" style="margin-top: 20px;">
      2.1 会员核心权益
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （1）卫星影像查看权益：乙方开通会员后，可按照会员等级对应的权限，查看“吉林一号共生地球”APP内标注为“会员专属”的卫星影像（包括实时影像、历史影像），且可访问对应影像的高清分辨率版本（具体分辨率以APP实际提供为准）。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （2）区域订阅权益：乙方可在APP内选择特定地理区域（需符合甲方划定的订阅范围）开通“区域订阅”，订阅后可接收该区域新增卫星影像的推送通知，并可优先查看该区域的影像更新内容。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （3）其他专属权益：乙方可享受会员专属客服通道（优先响应咨询需求）、会员专属活动参与权（如影像创作大赛、线下观测活动等），以及甲方后续新增的会员专属服务。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      2.2 使用限制
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （1）乙方仅可通过本人注册的“吉林一号共生地球”账号使用会员服务，不得将账号出租、出借、转让或出售给第三方，也不得与第三方共享会员权益（包括但不限于共同使用账号查看影像、转发会员专属影像给非会员用户）。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （2）乙方对会员服务下的卫星影像仅享有“个人或授权范围内的合理使用”权利，不得将影像用于以下行为：
    </div>
    <div class="content-text" style="margin-top: 0px;">
      a. 转售、倒卖卫星影像（包括但不限于单独出售影像或嵌入其他产品后出售）；
    </div>
    <div class="content-text" style="margin-top: 0px;">
      b. 声称卫星影像的知识产权归自己所有，或修改影像后隐瞒来源并用于商业或非商业传播；
    </div>
    <div class="content-text" style="margin-top: 0px;">
      c. 利用卫星影像从事违法活动（包括但不限于泄露国家秘密、侵犯他人隐私、传播虚假信息等）；
    </div>
    <div class="content-text" style="margin-top: 0px;">
      d. 超出甲方许可范围的其他使用行为（包括但不限于如未经授权将影像用于大规模商业广告、影视作品制作等）。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （3）乙方不得通过非甲方官方渠道（如第三方破解工具、非法插件）获取会员服务或篡改会员权益，否则甲方有权立即终止会员服务，且不退还已支付的会员费用。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （4）一旦甲方发现乙方存在上述（1）至（3）项任一违规行为，甲方有权立即单方终止本协议及会员服务，永久关闭乙方账号，且不退还任何已支付费用。同时，乙方应承担由此给甲方及第三方造成的全部损失，包括但不限于行政罚款、赔偿金、律师费、诉讼费、公证费等。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      第三条 会员费用与支付
    </div>
    <div class="content-text" style="margin-top: 20px;">
      3.1 会员服务为付费服务，具体费用标准（如月度会员、季度会员、年度会员等）以“吉林一号共生地球”APP内实时展示的价格为准，甲方有权根据市场情况调整定价，但调整前将在APP内公示至少3天。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      3.2 乙方需通过甲方官方提供的支付渠道（支付宝支付等）支付会员费用，支付完成后，会员服务将即时开通（特殊情况如系统延迟，开通时间不晚于支付完成后24小时），会员期限自开通当日起算，至约定届满日终止。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      3.3 会员服务属于虚拟数字服务，一经开通，除以下情形外，不支持退款、换货或兑换现金：
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （1）甲方系统故障导致会员服务无法开通或无法使用，且无法通过技术修复或补偿方案解决；
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （2）法律、行政法规明确规定应当退款的其他情形。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      3.4 乙方应确保支付账户信息真实、有效，因账户问题（如余额不足、支付密码错误、账户被冻结）导致支付失败或会员服务无法开通的，甲方不承担责任，乙方需自行与支付机构或账户所属方协商解决。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      第四条 会员期限与终止
    </div>
    <div class="content-text" style="margin-top: 20px;">
      4.1 会员期限以乙方与甲方约定的时长为准（如月度会员期限为30天、季度会员期限为90天年度会员期限为365天），期限届满后，会员服务自动终止，乙方需重新支付费用方可继续使用。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      4.2 若乙方出现以下情形，甲方有权单方面终止会员服务，且不退还已支付的会员费用：
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （1）违反本协议第二条“使用限制”约定，如出租账号、倒卖影像、违法使用影像等；
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （2）利用会员服务从事违反国家法律法规、损害甲方或第三方合法权益的行为；
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （3）乙方账号因违反《吉林一号共生地球服务协议》被甲方封禁或注销。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      4.3 若甲方因不可抗力（如地震、台风、政策调整、重大技术故障）导致会员服务无法继续提供，将提前通过APP公告通知乙方，并根据乙方剩余会员期限按比例退还相应费用（退费金额=已支付费用÷会员总期限×剩余期限）。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      4.4 乙方主动注销“吉林一号共生地球”账号的，会员服务自账号注销之日起终止，甲方不退还已支付的会员费用（法律另有规定的除外）。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      第五条 知识产权
    </div>
    <div class="content-text" style="margin-top: 20px;">
      5.1 “吉林一号共生地球”会员服务下的所有卫星影像（包括实时影像、历史影像）、影像相关数据及服务界面设计等知识产权，均归甲方或甲方授权方所有，甲方仅授予乙方“在会员期限内、基于本协议约定的使用范围”的非独占使用权，乙方不得主张对上述内容享有所有权或其他知识产权。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      5.2 乙方基于会员服务创作的内容（如影像解读文案、影像合成作品等），其知识产权归乙方所有，但乙方在使用该等创作内容时，不得侵犯甲方对卫星影像的知识产权，且需在创作内容中注明“卫星影像来源：吉林一号共生地球”（甲方另有书面许可的除外）。
    </div>
    <div class="content-text" style="margin-top: 0;">
      5.3 若乙方认为第三方利用“吉林一号共生地球”会员服务侵犯其知识产权，可向甲方提交书面权利通知（需包含侵权事实、权属证明等材料），甲方将根据法律法规及《吉林一号共生地球权利保护声明》进行处理；若乙方提交的权利通知存在虚假陈述，需承担由此给甲方或第三方造成的全部损失（包括律师费、诉讼费等）。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      第六条 责任限制与免责
    </div>
    <div class="content-text" style="margin-top: 20px;">
      6.1 甲方提供的卫星影像均基于实际观测数据生成，但受天气、卫星轨道、观测技术等因素影响，影像可能存在一定误差，甲方不对影像的绝对准确性、完整性作出保证，乙方需自行判断影像的使用风险（如用于科研、决策等场景时，应结合其他资料验证）。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      6.2 因以下甲方不可控因素导致会员服务中断或无法使用的，甲方不承担责任：
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （1）不可抗力（如自然灾害、战争、政府禁令等）；
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （2）网络服务提供商故障、黑客攻击、计算机病毒感染等技术问题；
    </div>
    <div class="content-text" style="margin-top: 0px;">
      （3）乙方设备（如手机、平板）故障、网络不稳定或操作不当。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      6.3 乙方违反本协议约定导致甲方或第三方遭受损失的，乙方需承担全部赔偿责任（包括甲方为维权支出的律师费、诉讼费、公证费等）；若甲方因此被有权机关处罚，乙方还需赔偿甲方的罚款损失。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      第七条 争议解决
    </div>
    <div class="content-text" style="margin-top: 20px;">
      7.1 双方就本协议产生的争议，应首先通过友好协商解决；协商不成的，任何一方均有权向甲方住所地（吉林省长春市）有管辖权的人民法院提起诉讼。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      7.2 本协议的订立、履行、解释及争议解决，均适用中华人民共和国法律（不包括港澳台地区法律）。
    </div>
    <div class="content-text" style="margin-top: 20px;">
      第八条 其他条款
    </div>
    <div class="content-text" style="margin-top: 20px;">
      8.1 本协议的任何条款被有权机关认定为无效或不可强制执行的，不影响其他条款的效力，其他条款仍对双方具有约束力。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      8.2 甲方未行使或延迟行使本协议项下的权利，不视为对该权利的放弃；甲方行使部分权利，不影响其行使其他权利。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      8.3 乙方确认，在开通会员前已充分阅读并理解本协议全部条款，尤其是“使用限制”“责任限制”“争议解决”等可能影响乙方权利的条款，甲方已就上述条款向乙方履行了提示说明义务。
    </div>
    <div class="content-text" style="margin-top: 0px;">
      8.4 本协议自乙方开通会员服务之日起生效，至会员期限届满或会员服务终止之日止。
    </div>
    <div class="content-text" style="margin-top: 40px;">
      长光卫星技术股份有限公司
    </div>
    <div class="content-text" style="margin-top: 0px;margin-bottom: 100px">
      生效日期：2025年xx月xx日
    </div>
  </div>
</template>

<script>
export default {
  name: 'MembershipServiceAgreement'
}
</script>

<style scoped>
.content-text {
  width: calc(100vw - 40px);
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
}
</style>